import { createClient }from "@sanity/client";

export default createClient({
  projectId: "r61nrfj3",
  dataset: "production",
  useCdn: true,
  apiVersion: "2023-02-01"
  
});